import { useColorModeValue } from '@chakra-ui/react';

/** Colores de texto y superficie con contraste en claro y oscuro */
export function useAppColors() {
  return {
    text: useColorModeValue('gray.800', 'gray.100'),
    muted: useColorModeValue('gray.600', 'gray.400'),
    subtle: useColorModeValue('gray.500', 'gray.400'),
    accent: useColorModeValue('pitch.600', 'pitch.300'),
    accentStrong: useColorModeValue('pitch.700', 'pitch.200'),
    border: useColorModeValue('gray.200', 'gray.600'),
    inputBg: useColorModeValue('gray.50', 'gray.800'),
    inputBorder: useColorModeValue('gray.300', 'gray.500'),
  };
}
